import { Routes } from './routes.constants';

export const accountRoutes: Array<string> = [
  Routes.Account,
  Routes.AccountDetails,
];
export const ticketRoutes: Array<string> = [Routes.AccountTickets];
